import { CustomerLayout } from "@/components/CustomerLayout/CustomerLayout";
import { DocumentError } from "@/components/DocumentError/DocumentError";
import { DocumentSkjoete } from "@/components/DocumentSkjoete/DocumentSkjoete";
import { routeLoaderApiClient } from "@/lib/api";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated-user/oppdrag/$tluxCaseId/skjøte/$skjoeteId/")({
  loader: async ({ params }) => {
    const { tluxCaseId, skjoeteId: skjøteId } = params;

    const res = await routeLoaderApiClient.oppdrag[":tluxCaseId"].skjøte[":skjøteId"].$get({
      param: {
        tluxCaseId,
        skjøteId,
      },
    });

    if (res.ok === false) {
      throw new Error("Failed to fetch skjøte");
    }

    return {
      response: await res.json(),
    };
  },
  head: ({ loaderData }) => {
    // We can infer that this is a tresidig skjøte if we have any utsteder actors
    let skjøteType = "skjøte";
    if (loaderData != null && loaderData.response.status === "success") {
      skjøteType =
        loaderData.response.skjøte.document.utstederActorRegisterenhetAndelIndexes == null
          ? "skjøte"
          : "tresidig-skjøte";
    }

    return {
      meta: [{ title: `Rediger ${skjøteType} | Alice & Bob` }],
    };
  },
  component: Page,
});

function Page() {
  const { tluxCaseId, skjoeteId: skjøteId } = Route.useParams();
  const { response } = Route.useLoaderData();

  if (response.status === "error") {
    return (
      <CustomerLayout>
        <DocumentError tluxCaseId={tluxCaseId} message={response.message} />
      </CustomerLayout>
    );
  }

  return (
    <CustomerLayout>
      <DocumentSkjoete
        tluxCaseId={tluxCaseId}
        skjøteId={skjøteId}
        skjøte={response.skjøte}
        cancelUrl={`/oppdrag/${tluxCaseId}`}
      />
    </CustomerLayout>
  );
}
